import { SearchableController } from "./SearchableController";
import { ControllerRegistry } from "../../Registry/ControllerRegistry";
import { MenuList } from "../../HTML/Menu/MenuList";

export class MenuController extends SearchableController {

    protected showSearchBox(): boolean {
        return false;
    }

    protected getResultItem() {
        return MenuList as any;
    }
}

ControllerRegistry.register("MenuController", MenuController);
